import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const HomePage = lazy(() => import("@/pages/home/page"));
const ApplyPage = lazy(() => import("@/pages/apply/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/apply",
    element: <ApplyPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;